(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-lr-collection]').forEach(root => {
      const label = root.querySelector('[data-lr-stock-filter]');
      if (!label || root.dataset.lrComplete !== 'true' || root.dataset.ready) return;
      root.dataset.ready = 'true';
      label.hidden = false;
      const checkbox = label.querySelector('input');
      checkbox.checked = new URL(location.href).searchParams.get('filter.v.availability') === '1';
      const cards = [...root.querySelectorAll('[data-lr-available]')];
      function filter() {
        cards.forEach(card => { card.hidden = checkbox.checked && card.dataset.lrAvailable !== 'true'; });
        const count = cards.filter(card => !card.hidden).length;
        root.querySelector('[data-lr-count]').textContent = root.dataset.countLabel.replace('__COUNT__', count);
        root.querySelector('[data-lr-empty]').hidden = count !== 0;
      }
      filter();
      checkbox.addEventListener('change', () => {
        filter();
        const url = new URL(location.href);
        if (checkbox.checked) url.searchParams.set('filter.v.availability', '1'); else url.searchParams.delete('filter.v.availability');
        history.replaceState({}, '', url);
      });
    });
    scope.querySelectorAll('[data-lr-product]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const variants = JSON.parse(root.querySelector('[data-lr-variants]').textContent);
      const select = root.querySelector('[data-lr-variant]');
      const image = root.querySelector('.lr-main-image img');
      const imageCenters = new Map();
      function centerImage() {
        if (!image?.complete || !image.naturalWidth) return;
        const src = image.currentSrc || image.src;
        if (!imageCenters.has(src)) {
          let center = { x: 0.5, y: 0.5 };
          try {
            // Recenter only white-background packshots; lifestyle photos keep their framing.
            const canvas = document.createElement('canvas');
            const sampleScale = 256 / Math.max(image.naturalWidth, image.naturalHeight);
            const w = canvas.width = Math.max(1, Math.round(image.naturalWidth * sampleScale));
            const h = canvas.height = Math.max(1, Math.round(image.naturalHeight * sampleScale));
            const ctx = canvas.getContext('2d', { willReadFrequently: true });
            ctx.drawImage(image, 0, 0, w, h);
            const pixels = ctx.getImageData(0, 0, w, h).data;
            const isWhite = (x, y) => {
              const i = (y * w + x) * 4;
              return pixels[i + 3] < 10 || Math.min(pixels[i], pixels[i + 1], pixels[i + 2]) > 242;
            };
            const edge = Math.max(1, Math.floor(Math.min(w, h) * 0.04));
            let whiteCorners = true;
            for (let y = 0; y < edge && whiteCorners; y++) {
              for (let x = 0; x < edge; x++) {
                if (![isWhite(x, y), isWhite(w - x - 1, y), isWhite(x, h - y - 1), isWhite(w - x - 1, h - y - 1)].every(Boolean)) {
                  whiteCorners = false;
                  break;
                }
              }
            }
            if (whiteCorners) {
              let left = w, top = h, right = -1, bottom = -1, count = 0;
              for (let y = 0; y < h; y++) {
                for (let x = 0; x < w; x++) {
                  if (!isWhite(x, y)) {
                    left = Math.min(left, x); right = Math.max(right, x);
                    top = Math.min(top, y); bottom = Math.max(bottom, y);
                    count++;
                  }
                }
              }
              if (count > w * h * 0.01) {
                const x = (left + right + 1) / (2 * w);
                const y = (top + bottom + 1) / (2 * h);
                if (Math.abs(x - 0.5) > 0.06 || Math.abs(y - 0.5) > 0.06) center = { x, y };
              }
            }
          } catch (_) {
            // Cross-origin or unreadable images retain the normal contain fallback.
          }
          imageCenters.set(src, center);
        }
        const center = imageCenters.get(src);
        const scale = Math.min(image.clientWidth / image.naturalWidth, image.clientHeight / image.naturalHeight);
        image.style.transform = `translate(${(0.5 - center.x) * image.naturalWidth * scale}px, ${(0.5 - center.y) * image.naturalHeight * scale}px)`;
      }
      if (image) {
        image.addEventListener('load', centerImage);
        centerImage();
        if ('ResizeObserver' in window) new ResizeObserver(centerImage).observe(image);
      }
      function changeImage(src, alt, full = src) {
        if (!image || !src) return;
        image.style.transform = '';
        // The old srcset must not override the selected variant's image.
        image.removeAttribute('srcset');
        image.src = src;
        image.alt = alt || image.alt;
        image.parentElement.href = full;
        root.querySelectorAll('[data-lr-image]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.lrImage === src)));
      }
      root.querySelectorAll('[data-lr-image]').forEach(button => button.addEventListener('click', () => changeImage(button.dataset.lrImage, button.dataset.alt, button.dataset.full)));
      function updateVariant() {
        const variant = variants.find(v => String(v.id) === select.value);
        if (!variant) return;
        const url = new URL(location.href);
        if (url.searchParams.get('variant') === String(variant.id)) return;
        url.searchParams.set('variant', variant.id);
        // Keep the selected model, purchase form and server-rendered JSON-LD together.
        location.assign(url.href);
      }
      if (select) {
        select.addEventListener('change', updateVariant);
        root.querySelector('[data-lr-swatches]').hidden = false;
        root.querySelectorAll('[data-lr-choice]').forEach(b => b.addEventListener('click', () => { select.value = b.dataset.lrChoice; select.dispatchEvent(new Event('change', { bubbles: true })); }));
      }
    });
    scope.querySelectorAll('[data-lr-menu]').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.addEventListener('keydown', e => { if (e.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
      document.addEventListener('click', e => { if (!menu.contains(e.target)) menu.open = false; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();

